export const listTemplateContextsConfig = () => ({
  url: `/template_contexts`,
});

export const getTemplateContextConfig = (id) => ({
  url: `/template_contexts/${id}`,
});

export const createTemplateContextConfig = () => ({
  url: `/template_contexts`,
});

export const updateTemplateContextConfig = (id) => ({
  url: `/template_contexts/${id}`,
});

export const deleteTemplateContextConfig = (id) => ({
  url: `/template_contexts/${id}`,
});
